import { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [{ title: "Tempt - Do Not Sell My Personal Information" }];
};

export default function DeleteUserData() {
  const handleClickOnManageCookies = () => {
    localStorage.removeItem("TERMLY_API_CACHE");
    window.location.reload();
  };
  
  return (
    <section className="text-white pt-10 min-h-screen terms">
      <div className="page-body">
        <div className="container mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6 text-white-800">
            Do Not Sell My Personal Information
          </h1>

          <p className="mb-4 ">
            Only for residents of CA, VA
          </p>

          <p className="mb-6 ">
            There are several ways to opt-out of interest-based advertising.
            “Opt-out” does not mean that you will stop seeing ads, it means that
            you will disable personalized advertising and ad quality might
            decrease.
          </p>

          <ol className="list-inside space-y-6">
            <li>
              <p className="mb-4 text-white-800 font-semibold">
                1. Change the privacy settings of your Android or Apple (iOS) device
              </p>

              <div className="space-y-4 pl-4">
                <div>
                  <p className="font-semibold ">Apple (iOS) devices:</p>
                  <p className="">For iOS 14 and newer:</p>
                  <ol className="list-decimal list-inside ml-4 mt-2 space-y-1 ">
                    <li>Open Settings</li>
                    <li>Select Privacy</li>
                    <li>Select Tracking and disable “Allow Apps to Request to Track”</li>
                  </ol>
                </div>

                <div>
                  <p className="">For iOS 13 and older:</p>
                  <ol className="list-decimal list-inside ml-4 mt-2 space-y-1 ">
                    <li>Open Settings</li>
                    <li>Select Privacy</li>
                    <li>Select Advertising and enable “Limit Ad Tracking”</li>
                  </ol>
                </div>

                <div>
                  <p className="font-semibold ">Android device:</p>
                  <p className="">To delete your device’s advertising ID:</p>
                  <ol className="list-decimal list-inside ml-4 mt-2 space-y-1 ">
                    <li>Open Settings</li>
                    <li>Tap Privacy &gt; Ads</li>
                    <li>Tap Delete advertising ID and confirm your changes</li>
                  </ol>
                </div>

                <div>
                  <p className="">If your Android device’s version is 4.4 or older:</p>
                  <ol className="list-decimal list-inside ml-4 mt-2 space-y-1 ">
                    <li>Open Settings</li>
                    <li>Tap Privacy &gt; Advanced &gt; Ads</li>
                    <li>Select Ads and enable “Opt out of Ads Personalization”</li>
                  </ol>
                </div>

                <p className="mt-4 ">
                  After changing device settings tap on{' '}
                  <button
                    onClick={handleClickOnManageCookies}
                    className="text-blue-600 hover:underline"
                  >
                    Opt-Out
                  </button>
                </p>
              </div>
            </li>

            <li>
              <p className="mb-4 text-white-800 font-semibold">
                2. If you have any questions or would like to submit an opt-out request to us directly, you can:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-2 ">
                <li>Use the in-app support feature (“Contact Us”) in our games;</li>
                <li>
                  Send us an e-mail at{' '}
                  <a
                    href="mailto:welcome@wromance.com"
                    className="text-blue-600 hover:underline"
                  >
                    welcome@wromance.com
                  </a>
                </li>
              </ul>
            </li>
          </ol>

          <p className="mt-6 ">
            Note that you may need to provide additional identifying information before we can process your request.
          </p>
        </div>
        <div className="w-full mt-6">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSc9vgZqiUq3LJp3i_8kXLXdJXDHuE3zunH5gZImG3Kwc5necQ/viewform?embedded=true"
            width="640" height="1400" frameBorder="0" marginHeight={0}
            className="mx-auto"
            marginWidth={0}>Loading…
          </iframe>
        </div>

      </div>

    </section>
  );
}
